import { AxiosError } from 'axios';
import { API, TrackerDataType } from '../constants/constants';
import {
  normalizeNotificationId,
  normalizeSendNotificationInput,
  normalizeSetNotificationsToRead,
} from '../utils/notificationsNormalization';

export enum NotificationType {
  TEAM_MEMBER_TAGGING = 'TEAM_MEMBER_TAGGING',
}

export interface Notification {
  _id: string;
  date: string;
  notificationType: NotificationType;
  redirectTo: string;
  receiver: UserId;
  sender: UserId;
  content: string;
  isRead: boolean;
  tenantIdDisc: string;
}

export const getNotificationsForCurrentUser = async (setNotificationsToRead: boolean = false) => {
  try {
    const normalizedSetNotificationsToRead = normalizeSetNotificationsToRead(setNotificationsToRead);
    const res = await API.get<{ notifications: Notification[] }>(`/notifications/user`, {
      params: { setNotificationsToRead: normalizedSetNotificationsToRead },
    });
    return res.data.notifications;
  } catch (err) {
    if (err instanceof AxiosError) {
      throw new Error(err.response?.data?.message ?? 'Error occurred when getting user notifications');
    } else {
      throw err;
    }
  }
};

export const sendNotification = async (
  destUserIds: string[],
  postId: string,
  postTitle: string,
  type: TrackerDataType
) => {
  try {
    const normalized = normalizeSendNotificationInput({
      destUserIds,
      emailService: 'aws',
      postId,
      postTitle,
      type,
    });
    if (!normalized) {
      throw new Error('Error occurred when sending user notification');
    }
    const res = await API.post('/notifications/user', {
      destUserIds: normalized.destUserIds,
      emailService: normalized.emailService,
      postId: normalized.postId,
      postTitle: normalized.postTitle,
      type: normalized.type,
    });

    return res.data;
  } catch (err) {
    if (err instanceof AxiosError) {
      throw new Error(err.response?.data?.message ?? 'Error occurred when sending user notification');
    } else {
      throw err;
    }
  }
};

export const deleteNotification = async (notificationId: string) => {
  try {
    const normalizedId = normalizeNotificationId(notificationId);
    if (!normalizedId) {
      throw new Error('Error occurred when deleting user notification');
    }
    const res = await API.delete(`/notifications/${normalizedId}`);

    return res.data;
  } catch (err) {
    if (err instanceof AxiosError) {
      throw new Error(err.response?.data?.message ?? 'Error occurred when sending user notification');
    } else {
      throw err;
    }
  }
};
